import { useModals } from '@any-ui-react/modals';
import type { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

import type { EmployeeVisaType } from '@/common/types';

import { VisaForm } from './VisaForm';

export const VisaModal = ({
  children,
  onSuccess,
  visa,
  className,
  isNewRecord = false,
}: {
  children: ReactNode;
  onSuccess: (data: EmployeeVisaType) => Promise<void>;
  visa?: EmployeeVisaType;
  className?: string;
  isNewRecord?: boolean;
}) => {
  const modalId = uuid();
  const { openModal, closeModal } = useModals();

  const onClick = () => {
    openModal({
      modalId,
      closeOnClickOutside: false,
      closeOnEscape: false,
      withinPortal: false,
      centered: true,
      title: `${!isNewRecord ? 'Update' : 'Add new'} Visa information`,
      size: 'lg',
      children: (
        <VisaForm
          visa={visa}
          onCancel={() => closeModal(modalId)}
          onSuccess={async data => {
            await onSuccess(data);
            closeModal(modalId);
          }}
        />
      ),
    });
  };

  return (
    <span className={className} onClick={onClick}>
      {children}
    </span>
  );
};
